import React from "react";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";

const Shippingpolicy = () => {
  const hostname = window.location.hostname;
  function getBaseDomain(hostname) {
    const parts = hostname.split(".");
    if (parts.length >= 2) {
      return parts.slice(-2).join(".");
    }
    return hostname;
  }
  return (
    <Container
      className="p-6 max-w-4xl mx-auto bg-white  rounded-lg"
      style={{ padding: "16px 16px" }}
    >
      <div className="">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">
          At {hostname}, We Aim to Provide Efficient Delivery Services Across
          India
        </h2>
        <section className="mb-4">
          {/* <h3 className="text-xl font-medium text-gray-700">
            Delivery Timeframe
          </h3>
          <p className="text-gray-600">
            All items purchased from our store are shipped across India and are
            typically delivered within 🚛 8 to 10 days from the order placement
            date and time.
          </p> */}
          <h3 className="text-xl font-medium text-gray-700">Processing Time</h3>
          <p>
            All orders are delivered within 8-10 business days. Orders are not
            shipped or delivered on weekends or holidays. If we are experiencing
            a high volume of orders, shipments may be delayed by a few days.
            Please allow additional days in transit for delivery. If there will
            be a significant delay in the shipment of your order, we will
            contact you via email or phone.
          </p>
        </section>

        {/* <section className="mb-4">
          <h3 className="text-xl font-medium text-gray-700">Possible Delays</h3>
          <p className="text-gray-600">
            While we strive to ensure timely delivery, please understand that
            occasional delays may occur due to unforeseen circumstances beyond
            our control. We appreciate your patience and understanding in such
            situations.
          </p>
        </section> */}

        {/* <section>
          <h3 className="text-xl font-medium text-gray-700">Shipping Time</h3>
          <p>
            Domestic Shipping: Orders will be delivered within 3 to 4 weeks from
            the date of order confirmation.
          </p>
          <p>
            Please note that delivery times may be affected by factors beyond
            our control, such as weather conditions, customs delays, and other
            unforeseen circumstances.
          </p>
        </section> */}

        <section>
          <h3 className="text-xl font-medium text-gray-700">Shipping policy</h3>
          <p>
            The product will be shipped with in 7-8 days and will be delivered
            with in 10-15 days
          </p>
        </section>

        <section>
          <h3 className="text-xl font-medium text-gray-700">Contact Us</h3>
          <p className="text-gray-600">
            If you have any questions or require assistance regarding your order
            or delivery, please don't hesitate to reach out to us at{" "}
            <a href={`mailto:support@${getBaseDomain(window.location.hostname)}`} className="text-blue-600">
              {getBaseDomain(window.location.hostname)}
            </a>
            . Our dedicated customer support team is here to help.
          </p>
        </section>
      </div>

      <div className="text-center mt-6">
        <h3
          style={{
            fontSize: "18px",
            fontWeight: 700,
            color: "#727272",
            textAlign: "center",
          }}
        >
          Get Our Newsletter
        </h3>
        <div className="Footer__Content Rte">
          Subscribe to receive updates, access to exclusive deals, and more.
        </div>
        <Form
          method="post"
          action="/contact#footer-newsletter"
          id="footer-newsletter"
          acceptCharset="UTF-8"
          className="my-3"
        >
          <input type="hidden" name="form_type" value="customer" />
          <input type="hidden" name="utf8" value="✓" />
          <input type="hidden" name="contact[tags]" value="newsletter" />
          <Form.Control
            size="lg"
            type="email"
            placeholder="Enter email"
            className="mb-3 pb-2"
          />
          <Button
            type="submit"
            variant="dark"
            style={{
              background: "var(--them-color)",
              borderColor: "var(--them-color)",
            }}
          >
            Subscribe
          </Button>
        </Form>
      </div>
    </Container>
  );
};

export default Shippingpolicy;
